import React from 'react';

const getPhotoUrl = (photo) => photo?.photo_url || photo?.url || photo?.path || "";

const getPhotoType = (photo, index) => photo?.photo_type || photo?.type || `Image ${index + 1}`;

const AssetPhotoGallery = ({
    assetId,
    photos = [],
    loading = false,
    updatingPhotoId,
    onCreatePhoto,
    onReplacePhoto,
    onOpenPreview,
    cardColClassName = "col-12 col-sm-6 col-md-4 col-xl-3",
    emptyMessage = "No images found for this asset.",
    inputIdPrefix = "replace-photo",
    loadingContent = <div className="text-muted">Loading images...</div>,
}) => {
    if (loading) {
        return loadingContent;
    }

    const isCreatingPhoto = String(updatingPhotoId || "").startsWith(`new-${assetId}-`);

    return (
        <div className="row g-3">
            <div className={cardColClassName}>
                <div className="asset-photo-card-wrap h-100">
                    <button
                        type="button"
                        className="asset-photo-camera-btn"
                        onClick={() => onCreatePhoto(assetId, photos)}
                        title="Upload photo"
                        disabled={isCreatingPhoto}
                    >
                        <i className={isCreatingPhoto ? "ri-loader-4-line" : "ri-camera-line"} />
                    </button>
                    <button
                        type="button"
                        className="asset-photo-card"
                        onClick={() => onCreatePhoto(assetId, photos)}
                    >
                        <div className="asset-photo-card-media d-flex align-items-center justify-content-center">
                            <div className="text-center">
                                <i className="ri-camera-line fs-2 d-block mb-2"></i>
                                <span className="small">Upload Asset Image</span>
                            </div>
                        </div>
                        <div className="asset-photo-card-body">
                            <div className="asset-photo-card-title">New Photo</div>
                            <p className="asset-photo-card-subtitle mb-0">
                                Choose photo type, then upload
                            </p>
                        </div>
                    </button>
                </div>
            </div>
            {photos.length ? (
                photos.map((photo, index) => {
                    const imageUrl = getPhotoUrl(photo);
                    const photoType = getPhotoType(photo, index);
                    const photoInputId = `${inputIdPrefix}-${photo.id || `${assetId}-${index}`}`;
                    const photoKey = photo?.id || `${photoType}-${index}`;

                    return (
                        <div
                            key={photo.id || `${assetId}-${index}`}
                            className={cardColClassName}
                        >
                            <div className="asset-photo-card-wrap h-100">
                                <input
                                    id={photoInputId}
                                    type="file"
                                    accept="image/*"
                                    className="d-none"
                                    onChange={(e) => {
                                        const file = e.target.files?.[0];
                                        if (file) {
                                            onReplacePhoto(photo, file);
                                        }
                                        e.target.value = "";
                                    }}
                                />
                                <button
                                    type="button"
                                    className="asset-photo-camera-btn"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        const input = document.getElementById(photoInputId);
                                        input?.click();
                                    }}
                                    title="Change photo"
                                    disabled={updatingPhotoId === photoKey}
                                >
                                    <i className={updatingPhotoId === photoKey ? "ri-loader-4-line" : "ri-camera-line"} />
                                </button>
                                <button
                                    type="button"
                                    className="asset-photo-card"
                                    onClick={() => onOpenPreview(imageUrl, photoType)}
                                    style={{ cursor: imageUrl ? "zoom-in" : "default" }}
                                    disabled={!imageUrl}
                                >
                                    {imageUrl ? (
                                        <img
                                            src={imageUrl}
                                            alt={photoType}
                                            className="asset-photo-card-media"
                                        />
                                    ) : (
                                        <div className="asset-photo-card-media d-flex align-items-center justify-content-center text-muted">
                                            No image URL
                                        </div>
                                    )}
                                    <div className="asset-photo-card-body">
                                        <div className="asset-photo-card-title">{photoType}</div>
                                        <p className="asset-photo-card-subtitle mb-0">
                                            {updatingPhotoId === photoKey ? "Updating photo..." : "Tap to view full image"}
                                        </p>
                                    </div>
                                </button>
                            </div>
                        </div>
                    );
                })
            ) : (
                <div className="col-12 text-muted">{emptyMessage}</div>
            )}
        </div>
    );
};

export default AssetPhotoGallery;
